import {
    ADD_LOCATION_FAIL,
    ADD_LOCATION_SUCCESS,
    DELETE_LOCATION_FAIL,
    DELETE_LOCATION_SUCCESS,
    EXPORT_LOCATION_FAIL,
    EXPORT_LOCATION_SUCCESS,
    GET_LOCATION_DETAILS_FAIL,
    GET_LOCATION_DETAILS_SUCCESS,
    GET_LOCATION_LISTING_FAIL,
    GET_LOCATION_LISTING_SUCCESS,
    RESET_LOCATION_ATTACHMENT_STATE,
    RESET_LOCATION_STATE,
    UPDATE_LOCATION_FAIL,
    UPDATE_LOCATION_SUCCESS
} from "./actionTypes"

const INIT_STATE = {
    locationListing: [],
    locationDetails: [],
    addLocation: [],
    updateLocation: [],
    deleteLocation: [],
    exportLocation: [],
    error: [],
}

const Location = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LOCATION_LISTING_SUCCESS:
            return {
                ...state,
                locationListing: action.payload
            }
        case GET_LOCATION_LISTING_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case GET_LOCATION_DETAILS_SUCCESS:
            return {
                ...state,
                locationDetails: action.payload
            }
        case GET_LOCATION_DETAILS_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case ADD_LOCATION_SUCCESS:
            return {
                ...state,
                addLocation: action.payload
            }
        case ADD_LOCATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case UPDATE_LOCATION_SUCCESS:
            return {
                ...state,
                updateLocation: action.payload
            }
        case UPDATE_LOCATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case DELETE_LOCATION_SUCCESS:
            return {
                ...state,
                deleteLocation: action.payload
            }
        case DELETE_LOCATION_FAIL:
            return {
                ...state,
                error: action.payload,
                deleteLocation: action.payload
            }

        case EXPORT_LOCATION_SUCCESS:
            return {
                ...state,
                exportLocation: action.payload
            }
        case EXPORT_LOCATION_FAIL:
            return {
                ...state,
                error: action.payload,
            }

        case RESET_LOCATION_STATE:
            return {
                ...state,
                locationListing: [],
                locationDetails: [],
                addLocation: [],
                updateLocation: [],
                deleteLocation: [],
                exportLocation: [],
                error: [],
            }
        case RESET_LOCATION_ATTACHMENT_STATE:
            return {
                ...state,
                exportLocation: [],
                error: [],
            }
        default:
            return state
    }
}

export default Location
